// components/Footer.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);

  // 判断是否为移动端
  const isMobile = window.innerWidth <= 768;

  // 展开/收起事件
  const handleMouseEnter = () => {
    if (!isMobile) setExpanded(true);
  };
  const handleMouseLeave = () => {
    if (!isMobile) setExpanded(false);
  };
  const handleClick = () => {
    if (isMobile) setExpanded((prev) => !prev);
  };

  return (
    <footer
      className={`footer-expandable${expanded ? ' expanded' : ''}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleClick}
    >
      <div className="footer-toggle-bar">
        <span style={{ fontSize: '0.85rem' }}>
          {expanded ? 'Hide site resources & legal info' : 'Show site resources & legal info'}
        </span>
      </div>
      <div className="footer-content">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-md-4 mb-0">
              <h6 className="text-uppercase mb-2 small-title">{t('Resources')}</h6>
              <ul className="list-unstyled mb-0">
                <li>
                  <Link to="/refund-policy" className="text-light text-decoration-none hover-effect small-text">
                    {t('Refund_Policy')}
                  </Link>
                </li>
                <li>
                  <Link to="/contact-support" className="text-light text-decoration-none hover-effect small-text">
                    {t('Contact_Support')}
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-md-4 mb-0">
              <h6 className="text-uppercase mb-2 small-title">{t('Legal')}</h6>
              <ul className="list-unstyled mb-0 compact-list">
                <li>
                  <Link to="/privacy-policy" className="text-light text-decoration-none hover-effect small-text">
                    {t('Privacy_Policy')}
                  </Link>
                </li>
                <li>
                  <Link to="/terms-of-use" className="text-light text-decoration-none hover-effect small-text">
                    {t('Terms_of_Use')}
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <style>{`
        .footer-expandable {
          position: fixed;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 1000;
          background: #222;
          color: #fff;
          border-top: 1px solid rgba(255,255,255,0.1);
          transition: height 0.35s cubic-bezier(0.4,0,0.2,1);
          overflow: hidden;
          height: 32px;
        }
        .footer-expandable .footer-toggle-bar {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 32px;
          cursor: pointer;
          background: rgba(34,34,34,0.95);
          border-top: 1px solid rgba(255,255,255,0.08);
        }
        .footer-expandable .footer-content {
          opacity: 0;
          pointer-events: none;
          transition: opacity 0.25s;
          height: 0;
        }
        .footer-expandable.expanded {
          height: 180px;
        }
        .footer-expandable.expanded .footer-content {
          opacity: 1;
          pointer-events: auto;
          height: auto;
          transition: opacity 0.35s 0.1s;
        }
        .footer-expandable .small-title {
          font-weight: 600;
          letter-spacing: 0.5px;
          font-size: 0.85rem;
          margin-top: 8px;
        }
        .footer-expandable .small-text {
          font-size: 0.8rem;
        }
        .footer-expandable .compact-list li {
          margin-bottom: 2px;
          line-height: 1.2;
        }
        @media (max-width: 768px) {
          .footer-expandable {
            height: 36px;
          }
          .footer-expandable.expanded {
            height: 240px;
          }
        }
        /* 防止内容被footer遮挡 */
        body {
          padding-bottom: 36px;
        }
        @media (min-width: 769px) {
          body {
            padding-bottom: 180px;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;
